import React, { useContext } from "react";

import { MapContext } from "../../contexts/map";
import MapControl, { ControlPosition } from "./MapControl";

import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import mapboxgl from "mapbox-gl";

var MapboxGeocoder = require("@mapbox/mapbox-gl-geocoder");

interface GeocoderControlProps {
  position: ControlPosition;
  options?: {
    marker?: boolean;
    minLength?: number;
    limit?: number;
    onResult?: (result: any) => void;
  };
}

const GeocoderControl: React.FC<GeocoderControlProps> = ({
  position,
  options = {},
}) => {
  const { accessToken } = useContext(MapContext);

  const geocoder = new MapboxGeocoder({
    accessToken: accessToken,
    mapboxgl: mapboxgl,
    ...options,
  });
  geocoder.on('result', (e: any) => {
    if (options.onResult) {
      options.onResult({
        result: {
          center: e.result.center
        }
      });
    }
  });
  return <MapControl control={geocoder} position={position} />;
};

export default GeocoderControl;
